import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '@strategy/strategy.actions';
import * as fromAppRoot from '@app/app.reducers';

@Component({
  selector: 'app-dialog-stability',
  templateUrl: './dialog-stability.component.html',
  styleUrls: ['./dialog-stability.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DialogStabilityComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Output() showWhyInyova = new EventEmitter<boolean>();
  editMode: boolean;
  kind: '3b' | '3a' | 'kid' | 'ci' | 'grow';
  step_status: number;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store
      .select(fromAppRoot.selectCustomerAndCurrentInvestAccount)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        if (!value || !value.currentAccountDetail || !value.currentAccountDetail.onboarding_step) {
          return;
        }
        this.editMode = value.currentAccountDetail.edit_mode;
        this.kind = value.currentAccountDetail.kind;
        this.step_status = value.currentAccountDetail.step_status;
      });
  }

  close(): void {
    this.showWhyInyova.emit(false);
  }

  backTo(tabIndex: number): void {
    this.store.dispatch(StrategyActions.setTabIndex({ tabIndex }));
    this.close();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
